export const getAccessToken = (cognitoUser) => {
  return cognitoUser && cognitoUser.accessTokenKey ? cognitoUser.accessTokenKey : '';
};
